import { css } from 'styled-components';
import Colours from '/shared/styled/Colours';

import IconTabTick from '/business/shared/images/icons/icon-tick-stylised-white.svg';
import IconPadlock from '/business/shared/images/icons/icon-padlock.svg';
import type { StyledHeaderTabsListItemProps } from '../types';

function isActiveStyle({ $isActive = false }: StyledHeaderTabsListItemProps) {
  if ($isActive) {
    return css<StyledHeaderTabsListItemProps>`
      height: 90px;
      margin-top: -10px;

      > div:first-child {
        color: ${Colours.black};

        span {
          color: ${Colours.black};
        }
      }

      > div:last-child {
        display: none;
      }
    `;
  }
}

function isDisabledStyle({ $isDisabled, $icon = null }: StyledHeaderTabsListItemProps) {
  if ($isDisabled && !$icon) {
    return css<StyledHeaderTabsListItemProps>`
      cursor: not-allowed;

      > div:last-child {
        display: block;
        background-image: url('${IconPadlock}');
        background-position: center center;
        background-repeat: no-repeat;
      }
    `;
  }
}

function isCompletedStyle({ $isCompleted, $icon = null }: StyledHeaderTabsListItemProps) {
  if ($isCompleted && !$icon) {
    return css<StyledHeaderTabsListItemProps>`
      > div:last-child {
        display: block;
        background-image: url('${IconTabTick}');
        background-position: center center;
        background-repeat: no-repeat;
      }
    `;
  }
}

function iconStyle({ $icon = null }: StyledHeaderTabsListItemProps) {
  if ($icon) {
    return css<StyledHeaderTabsListItemProps>`
      > div:last-child {
        display: block;
        background-image: url('${$icon}');
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 60%;
      }
    `;
  }
}

function isAvailableHoverStyle({ $isActive, $isDisabled }: StyledHeaderTabsListItemProps) {
  if (!$isActive && !$isDisabled) {
    return css<StyledHeaderTabsListItemProps>`
      &:hover {
        background: ${Colours.greenDark2};
      }
    `;
  }
}

export default function applicationListItemStyle({
  $isApplicationListItemStyle = false,
}: StyledHeaderTabsListItemProps) {
  if ($isApplicationListItemStyle) {
    return css<StyledHeaderTabsListItemProps>`
      height: 80px;
      margin: 0 5px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      > div:first-child {
        max-width: 120px;
        color: ${Colours.white};
        margin: auto 0;
        text-align: left;
        font-size: 13px;
        font-weight: 500;
        line-height: 18px;
        letter-spacing: 0.15px;
      }

      > div:last-child {
        display: none;
        color: transparent;
        border-radius: 50%;
        width: 42px;
        height: 42px;
        flex-shrink: 0;
        background-color: ${Colours.green};
      }
      ${isActiveStyle}
      ${isDisabledStyle}
      ${isCompletedStyle}
      ${isAvailableHoverStyle}
      ${iconStyle}
    `;
  }
}
